export default "/images/hero_img.png?92094d173856b7e2b4b0b32eb78fba80";